import { render, staticRenderFns } from "./MenuItems.vue?vue&type=template&id=9c5639ee&scoped=true&"
import script from "./MenuItems.vue?vue&type=script&lang=js&"
export * from "./MenuItems.vue?vue&type=script&lang=js&"
import style0 from "./MenuItems.vue?vue&type=style&index=0&id=9c5639ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5639ee",
  null
  
)

export default component.exports